import { Button } from '@civilgrid/ui/components';
import { useMutation } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { loadStagingLayerCatalog } from '~/api/internal';
import { Notify } from '~/components2/Notify';
import { formatLocalDateTime } from '~/pages/homeViewV2/utils';
import { MajorHeading } from '../common/Heading';

export default function LoadStagingLayerCatalog() {
  const mutation = useMutation({
    mutationKey: ['load-staging-layer-catalog'],
    mutationFn: loadStagingLayerCatalog,
    onSuccess: ({ rowCount, lastModified }) => {
      const source = lastModified ? ` (staging copy from ${formatLocalDateTime(lastModified)})` : '';
      Notify.info({ message: `Loaded ${rowCount} layers${source}` });
    },
    onError: (err) => {
      const reason = isAxiosError(err) ? err.response?.data?.reason : undefined;
      Notify.error({ message: reason || 'Failed to load the staging layer catalog. Check logs for details' });
    },
  });

  return (
    <div>
      <MajorHeading tooltip="Replace local tile layers with the latest staging catalog">
        Load staging layer catalog
      </MajorHeading>
      <Button
        data-testid="load-staging-layer-catalog-button"
        onClick={() => mutation.mutate()}
        loading={mutation.isPending}
        disabled={mutation.isPending}
      >
        Load
      </Button>
    </div>
  );
}
